import React, { useEffect, useState } from 'react'
import { useTransactions } from '../../hooks/useTransactions';
import { ArrowCircleDownIcon, ArrowCircleUpIcon } from "@heroicons/react/outline";
import { useCurrencyFormat } from '../../hooks/useCurrencyFormat'
import { useFormat } from '../../hooks/useFormat';
import { useLocation } from 'react-router-dom';
import { size } from 'lodash';


export const TransactionDetailScreen = () => {
  const parameters = useLocation();
  const { transactionId } = parameters.state;
  const { transaction, getTransactionById, formatDate } = useTransactions();
  const { formatWithCurrencyISO } = useCurrencyFormat();

  useEffect(() => {
    getTransactionById(transactionId);
  }, [])

  const { createDate, transactionNumber, products, currencyId, type, preferredName } = transaction;


  return (
    <>
      {
        size(transaction) > 0 ?
          <>
            <div className='w-full grid place-items-center'>
              <div className='border-0 w-full grid grid-cols-1'>
                <div className='border-0 col-span-1 grid place-items-center'>
                  <div className='bg-[#ebf3f0] w-[92px] h-[92px] rounded-full grid place-items-center mb-4'>
                    <img className='w-16' src={require("../../components/assets/images/send.png")} />
                  </div>
                </div>
                <div className='border-0 col-span-1 text-center font-semibold text-[17px]'>{products[0]?.displayName}</div>
                <div className='border-0 col-span-1 text-center font-light text-[15px] text-[#808080]'>{transaction.type == "PULL" ? "Pagaste" : "Te pagaron"}</div>
                <div className='border-0 col-span-1 text-center font-bold text-primary text-[22px] mt-4 mb-4'>{formatWithCurrencyISO(products[0]?.amount, currencyId)}</div>
              </div>
              <div className='px-5 sm:px-0 w-[350px] border-0'>
                <hr className='border-0 bg-[#e7e7e7]' />
                <div className='font-bold text-[18px] mb-8'>Detalles</div>
                <div className='border-0 grid gap-3 grid-cols-2'>
                  <div className='border-0 font-light text-[15px] col-span-1'>Fecha</div>
                  <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{formatDate(createDate)}</div>
                  <div className='border-0 font-light text-[15px] col-span-1'>ID Transacción</div>
                  <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{transactionNumber}</div>
                  <div className='border-0 font-light text-[15px] col-span-1'>Descripción</div>
                  <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.displayName}</div>
                  <div className='border-0 font-light text-[15px] col-span-1'>Concepto</div>
                  <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.concept}</div>
                  {
                    (products[0]?.reference.transactionType === 'BILL_PAYMENT') ?
                      <>
                        <div className='border-0 font-light text-[15px] col-span-1'>Número de factura</div>
                        <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.reference.reference.reference}</div>
                      </>
                      : null
                  }
                  {
                    (products[0]?.reference.transactionType === 'SHARE') ?
                      <>
                        <div className='border-0 font-light text-[15px] col-span-1'>De:</div>
                        <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{preferredName}</div>
                        <div className='border-0 font-light text-[15px] col-span-1'>Para:</div>
                        <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.reference.reference.preferredName}</div>
                      </>
                      : null
                  }
                  {
                    (products[0]?.reference.transactionType === 'CASH_OUT') ?
                      <>
                        <div className='border-0 font-light text-[15px] col-span-1'>Número de cuenta:</div>
                        <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.reference.reference.accountNumber}</div>
                        <div className='border-0 font-light text-[15px] col-span-1'>Referencia:</div>
                        <div className='border-0 font-semibold text-[15px] col-span-1 text-end'>{products[0]?.reference.reference.numericReference}</div>
                      </>
                      : null
                  }
                </div>
              </div>
            </div>
          </>
          : <div className='w-full h-full grid place-items-center' >No hay detalles</div>

      }
    </>
  )
}
